<template>
	<v-container class="mt-4  pr-4">
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1">Paquetes</span>
	  		    <v-spacer></v-spacer>

            <v-btn
              color="orange"
              dark
              class="mr-2"
              @click="dialog = true"
              small
              tile
            >
              <v-icon small>mdi-plus</v-icon>
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>
	  		  </v-card-title>

	  		  <v-card-text>
	  		    <v-row>
              <v-col cols="12" md="6" lg="4" xl="3" v-for="(paq, i ) in paquetes" :key="i">
                <v-card class="shadowCard">
                  <v-card-title>
                    <v-spacer></v-spacer>
                    {{ paq.paquete }}
                    <v-spacer></v-spacer>
                  </v-card-title>
                  <v-card-text class="text-center">
                    <v-row justify="space-around">
                      <v-col cols="6">
                        <v-card class="text-center white--text" color="primary">
                          <v-card-title class="text-subtitle-1 pb-0">
                            <v-spacer></v-spacer>
                            Clases
                            <v-spacer></v-spacer>
                          </v-card-title>
                          <v-card-text class="text-h3 white--text pt-0">
                            {{ paq.cant_clases }}
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="6">
                        <v-card class="text-center white--text" color="black">
                          <v-card-title class="text-subtitle-1 pb-0">
                            <v-spacer></v-spacer>
                            Límite
                            <v-spacer></v-spacer>
                          </v-card-title>
                          <v-card-text class="text-h3 white--text pt-0">
                            {{ paq.limite_dias }}
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                    <br/>
                    <span class="text-h5 black--text"><b>Costo:</b>{{ formatoMoneda( paq.costo ) }}</span>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn 
                      color="black"
                      icon
                      @click="editItem(paq)"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn 
                      color="red"
                      icon
                      @click="deleteItem(paq)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialog"
      max-width="400px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
          	<strong>ID: {{ editedItem.idpaquetes }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="editedItem.paquete"
            label="Paquete"
            filled
            dense
          ></v-text-field>

          <v-text-field
            v-model="editedItem.cant_clases"
            label="Cantidad de clases"
            filled
            type="number"
            dense
          ></v-text-field>

          <v-text-field
            v-model="editedItem.limite_dias"
            label="Limite de días"
            filled
            dense
            type="number"
          ></v-text-field>
          
          <v-text-field
            v-model="editedItem.costo"
            label="Costo"
            filled
            dense
            type="number"
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            tile
            small
            dark
            @click="close"
          >
          	<v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          
          <v-spacer></v-spacer>

          <v-btn
            color="green"
            dark
            small
            tile
            @click="save"
          >
          	<v-icon small left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el dato?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'


  export default {

    mixins: [ validarErrores, funcionesExcel ],

    components:{
      Alerta,
      carga,
    },

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
        idpaquetes:0,
				paquete:'',
        cant_clases:0,
        costo:0,
        limite_dias:0,
				deleted:0,
				fecha_creacion:null,
      },

      defaultItem: {
        idpaquetes:0,
        paquete:'',
        cant_clases:0,
        costo:0,
        limite_dias:0,
        deleted:0,
        fecha_creacion:null,
      },

      // tabla
			search:'',
      paquetes: [],
      headers: [
        { text: 'ID paquetes'     , value: 'idpaquetes'       },
        { text: 'Nombre completo' , value: 'paquete'  },
        { text: 'usuario'         , value: 'cant_clases'          },
        { text: 'Nivel'           , value: 'limite_dias'            },
        { text: 'Estatus'         , value: 'costo'          },
        { text: 'Fecha'           , value: 'fecha_creacion'   },
        { text: 'Actions'         , value: 'actions', sortable: false },
      ],
    }),

    computed: {
    	...mapGetters('login',['getdatosUsuario']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar categoria' : 'Editar categoria'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

    },

    async created () {
      await this.initialize()
    },

    methods: {
      initialize () {
      	this.cargar = true
        this.paquetes = []
        return this.$http.get('paquetes.list').then(response=>{
        	this.paquetes = response.body
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.paquetes.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.paquetes.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
      	this.cargar = true
        // Lo mandapos por el EP
        this.editedItem.deleted = 1
        this.$http.put('paquetes.update/' + this.editedItem.idpaquetes, this.editedItem).then(response=>{
        	this.cargar = true
        	this.closeDelete()
        	this.initialize()
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
      	if(this.editedItem.categoria == ''){
      		this.validarErrorDirecto('Favor de llenar todos los campos')
      	}
      	// Cargamos al usuario que hizo el cambio
	      this.cargar = true

        if (this.editedIndex > -1) {
	        // Lo mandapos por el EP
          this.$http.put('paquetes.update/' + this.editedItem.idpaquetes, this.editedItem).then(response=>{
          	this.validarSuccess( response.body.message )
          	this.initialize()
        		this.close()
	        }).catch( error =>{
          	this.validarError( error )
        	}).finally( () => { this.cargar = false })

        } else {
	        // Lo mandapos por el EP
          this.$http.post('paquetes.add', this.editedItem).then(response=>{
          	this.initialize()
	        	this.cargar = false
        		this.close()
	        }).catch( error =>{
          	this.validarError( error )
        	}).finally( () => { this.cargar = false })
        }
      },

      formatoMoneda(monto) {
        const formato = new Intl.NumberFormat('es-MX', {
          style: 'currency',
          currency: 'MXN',
        });

        return formato.format(monto);
      },
    },
  }
</script>


